module.exports = __webpack_public_path__ + "img/pyramid.1f78ce50.png";